import React from 'react'

export const isLiveStatus = status => {
  let result;
  switch (status) {
    case "confirmed":
    case "allocated":
    case "pickingUp":
    case "picked":
    case "droppingOff":
    case "onHold":
      result = true;
      break;
    default:
  }
  return result
}

export const isPickedStatus = status => {
  let result;
  switch (status) {
    case "picked":
    case "droppingOff":
    case "onHold":
    case "returned":
    case "delivered":
    case "cancelled":
    case "courierNotFound":
    case "onHold":
      result = true;
      break;
    default:
  }
  return result
}

export const isEndStatus = status => {
  let result;
  switch (status) {
    case "returned":
    case "delivered":
    case "cancelled":
    case "courierNotFound":
    case "onHold":
      result = true;
      break;
    default:
  }
  return result
}

export const isStatus = () => {
  
}


export const nextStatus = (oldStatus) => {
  let newStatus;

  switch (oldStatus) {
    case "placed":
      newStatus = 'confirmed';
      break;
    case "confirmed":
      newStatus = 'allocated';
      break;
    case "allocated":
      newStatus = 'pickingUp';
      break;
    case "pickingUp":
      newStatus = 'picked';
      break;
    case "picked":
      newStatus = 'droppingOff';
      break;
    case "droppingOff":
    case "onHold":
      newStatus = 'delivered';
      break;
    default:
  }
  return newStatus
};

export const statusTranslate = (status) => {
  let details;
  switch (status) {
    case "placed":
      details = 'Tersimpan';
      break;
    case "confirmed":
      details = 'Dikonfirmasi';
      break;
    case "allocated":
        details = 'Teralokasi';
    case "pickingUp":
    case "picking_up":
      details = 'Menjemput';
      break;
    case "picked":
      details = 'Terjemput';
      break;
    case "droppingOff":
    case "dropping_off":
      details = 'Dalam pengiriman';
      break;
    case "onHold":
    case "on_hold":
      details = 'Ditahan';
      break;
    case "rejected":
      details = 'Ditolak';
      break;
    case "cancelled":
      details = 'Tercancel';
      break;
    case "courierNotFound":
    case "courier_not_found":
      details = 'Tidak ada kurir';
      break;
    case "delivered":
      details = 'Selesai';
      break;
    default:
      details = '-';
  }
  return details;
};

export const normalizeTrackingStatus = (status) => {
  let newStatus;
  switch (status) {
    case "picking_up":
      newStatus = 'pickingUp';
      break;
    case "dropping_off":
      newStatus = 'droppingOff';
      break;
    case "courier_not_found":
      newStatus = 'courierNotFound';
      break;
    case "on_hold":
      newStatus = 'onHold';
      break;
    default:
      newStatus = status;
  }
  return newStatus;
};

export const courierBookingStatusDetails = (status, idx) => {
  let details;
  switch (status) {
    case "placed":
      details = 'Order masuk. Kurir akan segera dipesan pada waktu yang telah ditentukan.';
      break;
    case "confirmed":
      details = 'Sedang dicarikan kurir untuk penjemputan';
      break;
    case "allocated":
      if (idx === 1)
        details = 'Kurir ditugaskan dan siap-siap menjemput barang';
      else
        details = 'Kurir baru lainnya ditugaskan, siap-siap menjemput barang';
      break;
    case "pickingUp":
    case "picking_up":
      details = 'Kurir menuju lokasi penjemputan';
      break;
    case "picked":
      details = 'Barang sudah dijemput oleh kurir';
      break;
    case "droppingOff":
    case "dropping_off":
      details = 'Kurir sedang menuju lokasi pelanggan';
      break;
    case "onHold":
    case "on_hold":
      details = 'Pelanggan tidak dapat dihubungi. Barang masih ada di kurir';
      break;
    case "rejected":
      details = 'Kurir menolak untuk melakukan pengiriman barang';
      break;
    case "cancelled":
      details = 'Pengiriman di cancel';
      break;
    case "courierNotFound":
    case "courier_not_found":
      details = 'Kurir tidak ditemukan';
      break;
    case "delivered":
      details = 'Barang sudah diterima oleh pelanggan';
      break;
    default:
      details = '-';
  }
  return details;
};
